var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-apply-track"},[_c('orderItem')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }